<content-panel>
    <panel-header [heading]="serialNumber + ' - ' + defectViewItem?.ZoneName">
        <button mat-icon-button matTooltip="Close" (click)="closePanel()">
            <mat-icon>close</mat-icon>
        </button>
    </panel-header>
    <panel-body class="detail-view-container">
        <section class="row">
            <section class="column">
                <div class="body">
                    <div class="detail-view-element">
                        <label for="">Serial Number</label>
                        <div>{{ defectViewItem?.SerialNumber }}</div>
                    </div>
                    <div class="detail-view-element">
                        <label for="">Status</label>
                        @if(defectViewItem?.Status === 'Complete') {
                            <span class="complete">
                                <b>{{ defectViewItem?.Status }}</b>
                            </span>
                        } @else {
                            <span class="in-progress">
                                <b>{{ defectViewItem?.Status }}</b>
                            </span>
                        }
                    </div>
                </div>
            </section>
            <section class="column">
                <div class="body">
                    <div class="detail-view-element">
                        <label for="">Creation On</label>
                        <div>{{ defectViewItem?.CreationDate }}</div>
                    </div>
                    <div class="detail-view-element">
                        <label for="">Completed On</label>
                        <div>{{ defectViewItem?.CompletedOnDate }}</div>
                    </div>
                </div>
            </section>
            <section class="column">
                <div class="body">
                    <div class="detail-view-element">
                        <label for="">Completed By</label>
                        @if(defectViewItem?.CompletedByFirstName && defectViewItem?.CompletedByLastName) {
                        <div>{{defectViewItem?.CompletedByFirstName + ' ' + defectViewItem?.CompletedByLastName}}</div>
                        }
                    </div>
                    <div class="detail-view-element">
                        <label for="">Defect Count</label>
                        <div>{{ defectViewItem?.DefectCount }}</div>
                    </div>
                </div>
            </section>
        </section>
        <section class="row">
            <div class="header no-border">Defect History</div>
        </section>
        <section class="row scrollable">
            <table 
                mat-table
                [dataSource]="serialData"
            >
                <ng-container matColumnDef="Section">
                    <th mat-header-cell *matHeaderCellDef class="column-center">
                        <b>Section</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-center">
                        {{element.SectionName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Station">
                    <th mat-header-cell *matHeaderCellDef class="column-center">
                        <b>Station</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-center station-column">
                        {{element.StationName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="TaskName">
                    <th mat-header-cell *matHeaderCellDef class="column-center">
                        <b>Task Name</b>
                    </th>
                    <td mat-cell *matCellDef="let element" 
                    class="text-column"
                    [matTooltip]="element.TaskName">
                        {{element.TaskName}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="Category">
                    <th mat-header-cell *matHeaderCellDef class="column-center category-column">
                        <b>Category</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-center category-column">
                        @for(category of element.Category; track category) {
                            <div>{{category}}</div>
                        }
                    </td>
                </ng-container>
                <ng-container matColumnDef="DefectLoc">
                    <th mat-header-cell *matHeaderCellDef class="column-center loc-and-quantity">
                        <b>Defect Location</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-center loc-and-quantity">
                        {{element.DefectLocation}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="DefectQuantity">
                    <th mat-header-cell *matHeaderCellDef class="column-center loc-and-quantity">
                        <b>Defect Quantity</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="column-center loc-and-quantity">
                        {{element.Quantity}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="DefectDesc">
                    <th mat-header-cell *matHeaderCellDef class="column-center">
                        <b>Description</b>
                    </th>
                    <td mat-cell *matCellDef="let element" 
                    class="text-column"
                    [matTooltip]="element.Description">
                    @if(element.Description) {
                        {{element.Description}}
                    } @else {
                        <span class="na-styling">N/A</span>
                    }
                    </td>
                </ng-container>
                <ng-container matColumnDef="Images">
                    <th mat-header-cell *matHeaderCellDef class="photo-column">
                        <b>Image(s)</b>
                    </th>
                    <td mat-cell *matCellDef="let element" class="photo-column">
                        @if(!element.ImageLinks || element.ImageLinks.length === 0) {
                            <span class="na-styling">N/A</span>
                        } @else {
                            <ul>
                                @for(image of element.ImageLinks; track image) {
                                    <li>
                                        <button type="button" class="photo-name" (click)="previewPhoto(image)">
                                            {{image}}
                                        </button>
                                    </li>
                                }
                            </ul>
                        }
                    </td>
                </ng-container>
                <tr
                    mat-header-row
                    *matHeaderRowDef="tableColumns"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="
                    let row;
                    columns: tableColumns
                    "
                ></tr>
            </table>
        </section>
    </panel-body>
</content-panel>
